// Передача выделения из реестра в мастер укомплектования — на один переход, в памяти.
//
// Адрес источник правды для СОСТОЯНИЯ экрана, и это правило не отменяется. Но выделенные
// двадцать человек — не состояние экрана, а входные данные мастера: положить двадцать
// опознавателей в адресную строку значит сделать ссылку, которую нельзя ни прочитать, ни
// переслать, и упереться в предел длины адреса на четвёртом десятке.
//
// Поэтому передача одноразовая и переживает ровно один переход. Обновил страницу с открытым
// мастером — выделение не восстановилось, и это не поломка: список людей стоит прямо в
// мастере, отметить в нём можно там же. Молчаливого «половина выбранных потерялась» тут не
// бывает: либо всё, либо пусто и видно, что пусто.

let передано: readonly string[] = [];

export function запомнитьВыбор(ids: readonly string[]): void {
  передано = [...ids];
}

/** Забирает переданное и тут же очищает: второй мастер не должен унаследовать чужой выбор. */
export function взятьВыбор(): readonly string[] {
  const было = передано;
  передано = [];
  return было;
}

// У раздачи ссылок для входа ячейка СВОЯ, а не общая с укомплектованием. Общая была бы тем же
// самым ровно до первого случая, когда человек открыл один мастер, передумал и открыл второй:
// первая же читающая сторона ячейку очищает, и второй мастер получил бы пусто, не сказав об
// этом ни слова. Две ячейки стоят четырёх строк и снимают целый класс молчаливой потери.

/** Кого приглашаем: опознаватель и фамилия. */
export interface Приглашаемый {
  id: string;
  фамилия: string;
}

let приглашаемые: readonly Приглашаемый[] = [];

// Фамилия едет ВМЕСТЕ с опознавателем, а не добирается запросом в самом мастере. Реестр
// показывает срез (отбор, поиск, представление по типу оформления), и мастер, спросивший
// людей заново, спросил бы их ДРУГИМ запросом: выделенный человек мог бы в него не попасть, и
// из списка на раздачу он исчез бы молча.
export function запомнитьПриглашаемых(люди: readonly Приглашаемый[]): void {
  приглашаемые = люди.map((человек) => ({ ...человек }));
}

export function взятьПриглашаемых(): readonly Приглашаемый[] {
  const было = приглашаемые;
  приглашаемые = [];
  return было;
}
